import { useNavigate } from "react-router-dom";
import usersIcon from "../../../../assets/icons/Users.svg";

const UserMapCard = ({ assessmentId, assessmentName }) => {
  const navigate = useNavigate();

const handleClick = () => {
    if (!assessmentId) {
      console.warn("No assessment ID found");
      return;
    }
    const slug = (assessmentName || "assessment")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    navigate(`/masters-assessments/${slug}/assessment-mapping`, {
      state: { assessmentId: assessmentId }   
    });
  }
  return (
    <div
      className="card border-0 shadow-sm p-3 p-lg-4 h-100"
      style={{ minHeight: "100px" }}
    >
      <div
        className="p-2 d-flex align-items-center justify-content-between rounded"
        style={{ background: "#0D3744", minHeight: "87px" }}
      >
        <div className="d-flex align-items-center gap-3">
          <img
            src={usersIcon}
            alt="Users"
            className="ps-1"
            style={{ width: "50px", height: "50px" }}
          />
          <h6 className="mb-0 text-white">Users Map</h6>
        </div>
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1 mt-2">
        <p className="fw-normal mt-auto">
          Respected sir, sir My marks for Wireless and network Respected sir,
          sir My marks for Wireless and network
        </p>
        <button
          className="px-5 py-2 rounded-pill btn btn-outline mt-auto mb-1"
          style={{
            width: "100%",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
        >
          Map
        </button>
      </div>
    </div>
  );
};

export default UserMapCard;
